var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveFormat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.55 14.3h-.384l.318-.955-2.306-1.781-.911 2.736H7.15c-.304 0-.55.246-.55.55v1.1c0 .304.246.55.55.55h4.4c.304 0 .55-.246.55-.55v-1.1c0-.304-.246-.55-.55-.55zm10.238 1.447l-8.829-6.824 1.69-5.073H18.7v1.1c0 .304.246.55.55.55h1.1c.304 0 .55-.246.55-.55v-3.3c0-.304-.246-.55-.55-.55H6.05c-.304 0-.55.246-.55.55v1.51L1.563.115c-.115-.09-.262-.13-.406-.111C1.012.023.88.098.79.213l-.675.868c-.187.24-.143.586.096.772l20.225 15.631c.115.09.262.13.406.112.145-.018.277-.093.366-.208l.675-.87c.187-.239.143-.584-.096-.77zM10.653 7.142L7.7 4.859V3.85h4.05l-1.097 3.292z",
    transform: "translate(1 3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFormat);
export default __webpack_public_path__ + "static/media/remove-format.85751f0a19e21cb448972594648552c1.svg";
export { ForwardRef as ReactComponent };